var BUTTON_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  TERTIARY_BACK: 'tertiary_back',
  TERTIARY_NOICON: 'tertiary_noicon',
  SIGN_IN: 'sign_in'
};
var TEXT_HEIGHT = 21;

export { BUTTON_VARIANT, TEXT_HEIGHT };
